import { Component, OnInit, ChangeDetectorRef, Inject } from '@angular/core';
import { StatusConstant } from 'src/app/middleware/common/status/status-constant';
import { LoaderService } from 'src/app/middleware/shared/loader/loader.service';
import { ToastrService } from 'ngx-toastr';
import { EncryptionService } from 'src/app/middleware/encryption/encryption.service';
import { ReusableClasses } from 'src/app/middleware/common/reusableclassesAndFunctions/reusable-classes';
import * as jwt_decode from 'jwt-decode';
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FileManagerService } from '../services/fileManager.services';
import { DataSharingService } from 'src/app/middleware/common/resuableServices/data-sharing.service';


@Component({
  selector: 'associate-contact-role-filemanager-list-form',
  templateUrl: './associate-contact-role-filemanager-list.component.html',
  styleUrls: ['./associate-contact-role-filemanager-list.component.scss']
})
export class AssociateContactRoleFileManagerListComponent implements OnInit {

  
currentUser: any;
databaseId: string;
organizationId: string;
TransactionId:number;
responseHolder: any;
showAddButton = false;
peoples :any=[];  
mainModuleName:string="";  
action: any;
actionTypeArray: string[];
sharedContactRoleList :any=[]; 
OfficeIDList: any=[];
myOfficeID: any;
modulenameContact:string="";
spinner:boolean=false;

constructor(@Inject(MAT_DIALOG_DATA) public data: any,private fileManagerService: FileManagerService,
 private statusConst: StatusConstant, private loaderService: LoaderService, private toastr: ToastrService,
  private encryptionAlgo: EncryptionService, private reusableClass: ReusableClasses,
  private dialog: MatDialog, private cdr: ChangeDetectorRef,private _dataSharingService: DataSharingService) {

  const encryptedtoken = sessionStorage.getItem('userToken');
  this.databaseId = sessionStorage.getItem('databaseId');
  this.organizationId = sessionStorage.getItem('organizationID');
  const token = this.encryptionAlgo.get(this.reusableClass.encryptionKey, encryptedtoken);
  this.currentUser = jwt_decode(token);  
  var offices=JSON.parse(sessionStorage.getItem('officeList'));
      offices.forEach(oe => {
      this.OfficeIDList.push(oe.officeID)	
      if(oe.isMyoffice==true)
        this.myOfficeID=oe.officeID;
      });
}

ngAfterContentChecked(){
  this.cdr.detectChanges();
}

ngOnInit(): void {
  this.peoples=[]; 
  this.mainModuleName="File Manager";
  this.showAddButton=false;
  var menuModulesList = JSON.parse(sessionStorage.getItem("menuModules"));
  var Module =[];
  Module = menuModulesList.filter(x => x.mainModuleName == 'Contact');
   if(Module.length>0){
     this.modulenameContact= Module[0].orgModuleName;
   }
  this.getSharedContactRoleList();
}

async getSharedContactRoleList(){
  var FormFolderId;
  var typeId=0;
  var isFile= Object.values(this.data)[3];  
   // 1 for Folder , 2 for File
  if(isFile ==false){
    typeId=1;
    FormFolderId = Object.values(this.data)[1];
  }
  if(isFile ==true){
    typeId=2;
    FormFolderId =Object.values(this.data)[2];
  }
  var ReqModel={
    nameFieldID:0,
    emailFieldID:0,
    itemID:FormFolderId,
    itemType:typeId,
    pageIndex:0,
    pageSize:0,
    userID:this.currentUser.UID,
    organizationID:Number(this.organizationId),
    databaseID:Number(this.databaseId),   
    officeID:this.myOfficeID
  }    
  const result = await this.fileManagerService.GetAllFileFolderSharedTo(ReqModel).toPromise();
  if (result.status === this.statusConst.statusSuccess) {    
    this.responseHolder = result.data.fileSharedToList;
    if(this.responseHolder !=null){
      this.peoples = this.responseHolder;
      this.peoples.forEach(e => {
        e.shortName=e.name.match(/\b(\w)/g).join('');
        if(e.imageUrl==null){
          e.imageUrl="";
        }
        if(e.shareToType==4){
          e.name = this.encryptionAlgo.get(this.reusableClass.decryptionKey, e.name);
          e.shortName = e.name.match(/\b(\w)/g).join('');
        }
      });
    }else{
      this.peoples=[];
    }      
  }
  else {
    this.peoples=[];
  } 
}

getActionType(actionType){
  if(actionType==-1)
  return this.actionTypeArray= ["Remove"];
  if(actionType==0)
  return this.actionTypeArray= ["Viewer"];
  if(actionType==1)
  return this.actionTypeArray= ["Editor"];
}

actionSelected(action,actionType,shareToID){
   this.peoples.find(m=>m.shareToID==shareToID).permission=actionType;
   var data =  this.peoples.filter(m=>m.shareToID==shareToID);   
   for (var user = 0; user < data.length; user++) {
    var ReqModel = {
      shareID: data[user].shareID,
      shareToID: data[user].shareToID,
      shareToType: data[user].shareToType,
      actionType: data[user].permission
      }
      this.sharedContactRoleList.push(ReqModel);
    }
    if(this.sharedContactRoleList.length > 0){
      this.showAddButton=true;
    }
    else{
      this.showAddButton=false;
    }
}

FormFolderContactRoleUpdate(){
  this.spinner=true;
  this.showAddButton=false;
  var FormFolderId;
  var isFile= Object.values(this.data)[3];  
   // 1 for Folder , 2 for File
  if(isFile ==false){ 
    FormFolderId = Object.values(this.data)[1];
  }
  if(isFile ==true){
    FormFolderId =Object.values(this.data)[2];
  }  
   if(this.sharedContactRoleList.length > 0) { 
      let ReqModel = {
       id: FormFolderId,
       userID : this.currentUser.UID,
       shareTo : this.sharedContactRoleList,
       organizationID : Number(this.organizationId),
       databaseID : Number(this.databaseId),
       officeID:this.myOfficeID
       }
       this.fileManagerService.ModifyShareFileFolder(ReqModel).subscribe(response => {
         if (response != undefined) {
          this.spinner=false;
           this.responseHolder = response;
           if (this.responseHolder.status == this.statusConst.statusSuccess) {
             this.toastr.success('Record updated successfully.', '', {
               timeOut: 3000,
             });
             this.loaderService.hide();
             this.close();
             this._dataSharingService.sendRefreshDetailsSharedRoleListForFileManager(true); 
           }
           else {
             this.loaderService.hide();
             this.close();
           }
         }else{
          this.spinner=false;
         }
       });
     } else {
         this.loaderService.hide();
         this.spinner=false;
         this.close();
    }  
}

  close() {
   this.showAddButton=false;
   this.sharedContactRoleList =[];
   this.dialog.closeAll();  
  }


}
